import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  reportScheduleApi,
  type CreateReportScheduleRequest,
  type UpdateReportScheduleRequest,
} from '@/lib/api';

// V128 / Tier 2.4 — scheduled email reports.
export const useReportSchedules = (workspaceId: string) =>
  useQuery({
    queryKey: ['report-schedules', workspaceId],
    queryFn: () => reportScheduleApi.list(workspaceId),
    enabled: !!workspaceId,
  });

export const useCreateReportSchedule = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateReportScheduleRequest) => reportScheduleApi.create(workspaceId, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['report-schedules', workspaceId] }),
  });
};

export const useUpdateReportSchedule = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: UpdateReportScheduleRequest }) =>
      reportScheduleApi.update(workspaceId, id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['report-schedules', workspaceId] }),
  });
};

export const useDeleteReportSchedule = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => reportScheduleApi.delete(workspaceId, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['report-schedules', workspaceId] }),
  });
};

export const useSendReportNow = (workspaceId: string) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => reportScheduleApi.sendNow(workspaceId, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['report-schedules', workspaceId] }),
  });
};
